/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LightOrderDto } from './lightOrderDto';


export interface ReplacedItemsNotificationDto { 
    id?: number;
    isRead?: boolean;
    createdDate?: string;
    order?: LightOrderDto;
    replacedArticleName?: string | null;
    replacementArticlesName?: Array<string> | null;
}

